import {
	FacetOptions,
	FieldSuggestionsOptions,
	SortCriterion,
	buildFieldSuggestions,
	buildRelevanceSortCriterion,
} from "@coveo/headless";
import { drhHeadlessEngine } from "../../system/engine/engine";
import { getDynamicFieldName } from "drh-js-library/src/community-finder/field-utils/get-dynamic-fieldname";

import DrhCoveoFieldsEnum from "../../util/maps-enums/DrhCoveoFieldsEnum";

const facetOptions: FacetOptions = {
	field: getDynamicFieldName(DrhCoveoFieldsEnum.AutoComplete.fieldName),
	numberOfValues: 100,
	facetSearch: { numberOfValues: 1000 },
	sortCriteria: "automatic",
};

const options: FieldSuggestionsOptions = { facet: facetOptions };

export const fieldSuggestions = buildFieldSuggestions(drhHeadlessEngine, {
	options,
});
